export const formStructure = [
  [
    {
      name: 'nomeFilial',
      label: 'Nome da Filial',
      placeholder: 'Digite o nome da filial',
      component: 'FormField',
      type: 'text',
      colProps: { md: 8 },
      required: true,
      maxLength: 120,
      validation: { required: 'Nome da filial e obrigatorio' },
    },
  ],
];

export const formSections = initialValues => [
  {
    title: `Detalhes da Filial ${initialValues.nomeFilial || ''}`,
    rows: [0],
  },
];

export const validateForm = values => {
  const errors = {};

  if (!values?.nomeFilial || String(values.nomeFilial).trim().length === 0) {
    errors.nomeFilial = 'Nome da filial e obrigatorio';
  }

  return errors;
};
